<script>
import MainLayout from '@/router/layouts/mainLayout'
import { formatDate, DateUtil } from '@/utils/date.js'
import { StringUtil } from '@/utils/StringUtil.js'

import showMap from '@/components/showMapWindowMask'
import mapDropPin from '../../assets/map_icon/map_drop_pin.png'

export default {
  components: {
    MainLayout, showMap
  },
  data () {
    return {
      shiftId: '',
      shiftInfo:{
        shiftPasspoints:[]
      },
      shiftInfoOriginal:{},
      userInfo:[],
      driverList:[],
      vehicleList:[],
      additionalHomeList:[],
      actualTimeError1: false,
      actualTimeError2: false,
      actualTimeError3: false,
      distanceError: false,
      passengerNumberError1: false,
      passengerNumberError2: false,
      transportIdError: false,
      driverError: false,
      vehicleError: false,
      waitTimeError: false,
      businessStartTimeError: false,
      moveStartTimeError: false
    }
  },
  created(){
    console.log(this.$route.query.shiftId)
    this.shiftId = this.$route.query.shiftId
    // オリジナル便情報取得 表示用
    this.$axios.get('shift/queryShiftInfoDetailOriginal', {params: {shiftId: this.shiftId}})
      .then(response => {
        console.log("queryShiftInfoDetailOriginal")
        console.log(response)
        let shiftInfoTemp = response.data.shiftInfo
        this.shiftInfoOriginal = shiftInfoTemp
        this.getRouteName(shiftInfoTemp.routeId)
        // ※APIがdriverUidではなく"driveUid"という名前で返してくる
        this.shiftInfoOriginal.driverUid = shiftInfoTemp.driveUid

        // 表示用index作成
        let passCount = 0;
        let homeCount = 0;
        for(let i = 0; i < this.shiftInfoOriginal.shiftPasspoints.length; i++){
          if(this.shiftInfoOriginal.shiftPasspoints[i].routeType == 0){
            passCount++
            this.shiftInfoOriginal.shiftPasspoints[i].frontIndex = passCount
          }else if(this.shiftInfoOriginal.shiftPasspoints[i].routeType == 1){
            homeCount++
            this.shiftInfoOriginal.shiftPasspoints[i].frontIndex = homeCount
          }
        }

        this.relateShiftInfoToReservationInfo(this.shiftInfoOriginal)
        // 描画を更新
        this.shiftInfoOriginal.shiftPasspoints.splice(0,this.shiftInfoOriginal.shiftPasspoints)
      })
    // 便情報取得 編集用
    this.$axios.get('shift/queryShiftInfoDetail', {params: {shiftId: this.shiftId}})
      .then(response => {
        console.log("queryShiftInfoDetail")
        console.log(response)
        let shiftInfoTemp = response.data.shiftInfo
        this.shiftInfo = shiftInfoTemp
        // ※APIがdriverUidではなく"driveUid"という名前で返してくる
        this.shiftInfo.driverUid = shiftInfoTemp.driveUid

        // 業務開始時刻を変換
        this.shiftInfo.businessStartTimeHour = this.getHourAsNum(this.shiftInfo.businessStartTime)
        this.shiftInfo.businessStartTimeMin = this.getMinAsNum(this.shiftInfo.businessStartTime)

        // 運行開始時刻を変換
        this.shiftInfo.moveStartTimeHour = this.getHourAsNum(this.shiftInfo.moveStartTime)
        this.shiftInfo.moveStartTimeMin = this.getMinAsNum(this.shiftInfo.moveStartTime)

        // 停留所と自宅の関連付け
        this.relateShiftInfoToReservationInfo(this.shiftInfo)
        
        // 編集用停留所リストに自宅で降車していない予約者の自宅を追加する
        for(let reserveIndex = 0; reserveIndex < this.shiftInfo.shiftReservationInfos.length; reserveIndex++){
          let found = false
          for(let passpointIndex = 0; passpointIndex < this.shiftInfo.shiftPasspoints.length; passpointIndex++){
            if(this.shiftInfo.shiftPasspoints[passpointIndex].reserveId === this.shiftInfo.shiftReservationInfos[reserveIndex].reserveId){
              found = true
            }
          }
          // 降車地が自宅以外の場合
          if(!found){
            let addPasspoint = {}
            addPasspoint.arriveActualTime = null
            addPasspoint.isEnable = false
            addPasspoint.reserveId = this.shiftInfo.shiftReservationInfos[reserveIndex].reserveId
            addPasspoint.routeNo = 0
            addPasspoint.routeType = "1"
            addPasspoint.sortNo = 0
            addPasspoint.stationId = this.shiftInfo.shiftReservationInfos[reserveIndex].reserveId
            addPasspoint.stationName = this.shiftInfo.shiftReservationInfos[reserveIndex].lastName + " " + this.shiftInfo.shiftReservationInfos[reserveIndex].firstName
            addPasspoint.arrivePassengerList = []
            addPasspoint.startPassengerList = []
            addPasspoint.newPointFlag = 1
            addPasspoint.deletePointFlag = 0

            if(this.shiftInfo.shiftFlag === 0){
              this.shiftInfo.shiftPasspoints.splice(1,0,addPasspoint)
            }else{
              this.shiftInfo.shiftPasspoints.splice(this.shiftInfo.shiftPasspoints.length - 1,0,addPasspoint)
            }
          }else{
            if(this.shiftInfo.shiftFlag === 0){
              this.shiftInfo.shiftReservationInfos[reserveIndex].startStationId = this.shiftInfo.shiftReservationInfos[reserveIndex].reserveId
            }else{
              this.shiftInfo.shiftReservationInfos[reserveIndex].arriveStationId = this.shiftInfo.shiftReservationInfos[reserveIndex].reserveId
            }
          }
        }
        // sortNoを振り直す
        for(let passpointIndex = 0; passpointIndex < this.shiftInfo.shiftPasspoints.length; passpointIndex++){
          this.shiftInfo.shiftPasspoints[passpointIndex].sortNo = passpointIndex + 1
        }

        for(let passIndex = 0; passIndex < this.shiftInfo.shiftPasspoints.length; passIndex++){
          for(let reserveIndex = 0; reserveIndex < this.shiftInfo.shiftReservationInfos.length; reserveIndex++){
            // 乗車場所より前の位置の降車場所は選択させない
            if(this.shiftInfo.shiftPasspoints[passIndex].stationId === this.shiftInfo.shiftReservationInfos[reserveIndex].startStationId){
              this.shiftInfo.shiftReservationInfos[reserveIndex].startStationNumber = this.shiftInfo.shiftPasspoints[passIndex].sortNo
            }
            // 乗車場所降車場所が自宅の場合の初期値をセット
            if(this.shiftInfo.shiftReservationInfos[reserveIndex].arrivePlaceType === 1){
              shiftInfoTemp.shiftReservationInfos[reserveIndex].arriveStationId = shiftInfoTemp.shiftReservationInfos[reserveIndex].reserveId
            }
            if(this.shiftInfo.shiftReservationInfos[reserveIndex].startPlaceType === 1){
              shiftInfoTemp.shiftReservationInfos[reserveIndex].startStationId = shiftInfoTemp.shiftReservationInfos[reserveIndex].reserveId
            }
          }
        } 
        // 表示用index更新
        this.updateFrontIndex()
        this.changeActualTime()
      })
    // ドライバー一覧取得
    this.$axios.get('shift/selectInfoName').then(response => {
      this.userInfo = response.data.userInfo
      this.userInfo.forEach(item => {
        if (!StringUtil.isEmpty(item.roleFlag) &&
          (item.roleFlag.substring(1, 2) === '1' || item.roleFlag.substring(4, 5) === '1')) {
          this.driverList.push(item)
        }
      })
      this.driverList.sort((x, y) => {
        return (x.lastNamekana + x.firstNamekana).localeCompare(
          y.lastNamekana + y.firstNamekana
        )
      })
    })
    // 車両一覧取得
    this.$axios.get('shift/selectVehicleInfo').then(response => {
      this.vehicleList = response.data.vehicleInfo
    })
    
  },
  methods: {
    debugLog(){
      console.log(this.shiftInfoOriginal)
      console.log(this.shiftInfo)
    },
    getShiftId (val) {
      this.shiftId = val
    },
    getRouteName(routeId){
      this.$axios.get('shift/queryRouteNameById', {params: {routeId: routeId}})
        .then(response => {
          this.shiftInfoOriginal.routeName = response.data.routeName
          // 描画を更新
          this.shiftInfo.shiftPasspoints.splice(0,this.shiftInfo.shiftPasspoints)

          return
        })
        .catch(function (error) {
          console.log(error)
          return
        })
    },

    // 8桁年月日を表示用に変換する yyyyMMdd 
    getYearWeek (dateStr) {
      if (dateStr == null || dateStr == '') {
        return ''
      }
      return DateUtil.yearWeek(dateStr)
    },

    // 12桁年月日時刻を表示用に変換するyyyyMMddHHmmss 
    getHourMin (dateStr) {
      if (dateStr == null || dateStr == '') {
        return ''
      }
      return dateStr.substr(8, 2) + ':' + dateStr.substr(10, 2)
    },
    // 12桁日付時刻のhour部分のみを数値に変換する 0サプレス
    getHourAsNum (dateStr) {
      if (dateStr == null || dateStr == '') {
        return ''
      }
      return Number(dateStr.substr(8, 2))
    },
    // 12桁日付時刻のminute部分のみを数値に変換する 0サプレス
    getMinAsNum (dateStr) {
      if (dateStr == null || dateStr == '') {
        return ''
      }
      return Number(dateStr.substr(10, 2))
    },
    hourMinToMin(dateStr){
      let min = 0
      if (dateStr == null || dateStr == '') {
        return 0
      }else{
        let hour = this.getHourAsNum(dateStr)
        min = this.getMinAsNum(dateStr)
        min = (hour * 60) + min
      }
      return min
    },
    // 数値に0をつけて2桁の文字列に変換する 0埋め
    addPreZero (number) {
      return number > 9 ? number.toString() : '0' + number
    },
    
    // ドライバー選択時処理
    async changeDriver(){
      // フリガナを取得
      for (let i = 0; i < this.driverList.length; i++) {
        if (this.driverList[i].uid === this.shiftInfo.driverUid) {
          this.shiftInfo.driverNameKana = this.driverList[i].lastNamekana + ' ' + this.driverList[i].firstNamekana
          break
        }
      }
      this.driverError = await this.checkDriverSchedule()
      this.checkTransportId()
    },

    async checkDriverSchedule(){
      console.log("checkDriverSchedule")
      // 選択したドライバーに他の予定がないかチェック
      // submit時にも実行しており、その場合はaxiosが終わるまでしっかり待ちたいのでT/Fをreturnで返す形にした
      // 予定あり→trueを返す
  
      let driverError = false
      if(this.shiftInfo.driverUid != null && this.shiftInfo.driverUid !== ""){
        // ドライバースケジュールリストを取得
        return await this.$axios.get('shift/selectShiftTimeInfoListByDriverUid',
          {params: {driverUid: this.shiftInfo.driverUid, moveShiftTime: this.shiftInfoOriginal.moveShiftTime}})
          .then(response => {
            console.log(response)
            let shiftTimeInfoListByDriverUid = response.data.shiftTimeInfoListByDriverUid
            // 同じ便は除く
            shiftTimeInfoListByDriverUid = shiftTimeInfoListByDriverUid.filter((item) => item.shiftId !== this.shiftInfo.shiftId)
            // 出発地の時刻を取得
            let currentShiftStartTime = this.shiftInfo.shiftPasspoints[0].arriveActualTime
            // 到着地の時刻を取得
            let currentShiftEndTime = this.shiftInfo.shiftPasspoints[this.shiftInfo.shiftPasspoints.length - 1].arriveActualTime
  
            for (let i = 0; i < shiftTimeInfoListByDriverUid.length; i++) {
              // 終了便は除く
              if(shiftTimeInfoListByDriverUid[i].shiftMovementStatus !== 3){
                // ドライバー予定を時刻順にソート
                shiftTimeInfoListByDriverUid[i].shiftPasspointTime.sort((a, b) => { return a.sortNo - b.sortNo })
                // 一番はやい時刻を取得
                let startTime = shiftTimeInfoListByDriverUid[i].shiftPasspointTime[0].startEstimateTime
                // 一番おそい時刻を取得
                let endTime = shiftTimeInfoListByDriverUid[i].shiftPasspointTime[shiftTimeInfoListByDriverUid[i].shiftPasspointTime.length - 1].arriveEstimateTime
                if (!StringUtil.isEmpty(startTime) && (startTime.length === 14) && !StringUtil.isEmpty(endTime) && (endTime.length === 14)) {
                  if (!(DateUtil.stringToDate(startTime) > DateUtil.stringToDate(currentShiftEndTime) ||
                      DateUtil.stringToDate(endTime) < DateUtil.stringToDate(currentShiftStartTime))) {
                      driverError = true
                  }
                }
              }
            }
            return driverError
          })
      }
    },

    // 車両選択時処理
    async changeVehicle(){
      this.vehicleError = await this.checkVehicleSchedule()
      this.checkTransportId()
      this.shiftInfo.shiftPasspoints.splice(0,this.shiftInfo.shiftPasspoints)

    },

    // 選択した車両に他の予定がないかチェック
    // 予定あり→trueを返す
    async checkVehicleSchedule(){
      let vehicleError = false
      if(this.shiftInfo.vehicleId != null && this.shiftInfo.vehicleId !== ""){
        return await this.$axios.get('shift/selectShiftTimeInfoList',
          {params: {vehicleId: this.shiftInfo.vehicleId, moveShiftTime: this.shiftInfoOriginal.moveShiftTime}})
          .then(response => {
            console.log(response)
            let shiftTimeInfoList = response.data.shiftTimeInfoList

            // 出発地の時刻を取得
            let currentShiftStartTime = this.shiftInfo.shiftPasspoints[0].arriveActualTime
            // 到着地の時刻を取得
            let currentShiftEndTime = this.shiftInfo.shiftPasspoints[this.shiftInfo.shiftPasspoints.length - 1].arriveActualTime

            for (let i = 0; i < shiftTimeInfoList.length; i++) {
              // 同じ便は除く
              if(shiftTimeInfoList[i].shiftId != this.shiftInfo.shiftId){
                if(shiftTimeInfoList[i].shiftMovementStatus !== 3){
                  // 車両予定を時刻順にソート
                  shiftTimeInfoList[i].shiftPasspointTime.sort((a, b) => { return a.sortNo - b.sortNo })
                  // 一番はやい時刻を取得
                  let startTime = shiftTimeInfoList[i].shiftPasspointTime[0].startEstimateTime
                  // 一番おそい時刻を取得
                  let endTime = shiftTimeInfoList[i].shiftPasspointTime[shiftTimeInfoList[i].shiftPasspointTime.length - 1].arriveEstimateTime
                  if (!StringUtil.isEmpty(startTime) && (startTime.length === 14) && !StringUtil.isEmpty(endTime) && (endTime.length === 14)) {
                    if (!(DateUtil.stringToDate(startTime) > DateUtil.stringToDate(currentShiftEndTime) ||
                          DateUtil.stringToDate(endTime) < DateUtil.stringToDate(currentShiftStartTime))) {
                      vehicleError = true
                    }
                  }
                }
              }
            }
            return vehicleError
          })
      }
    },

    relateShiftInfoToReservationInfo(shiftInfoTemp){
      console.log("relateShiftInfoToReservationInfo")
      console.log(shiftInfoTemp)
      // 停留所と乗客の関連付け
      // shiftPasspointsの停留所ごとに予約者一覧を作る
      let homeIndex = 0
      for(let passIndex = 0; passIndex < shiftInfoTemp.shiftPasspoints.length; passIndex++){
        // 最初の停留所 or 最後の停留所 or 自宅の場合 or 予約がある場合 有効フラグをセット
        if(passIndex === 0
        || passIndex === shiftInfoTemp.shiftPasspoints.length - 1){
          shiftInfoTemp.shiftPasspoints[passIndex].isEnable = true
        }else{
          shiftInfoTemp.shiftPasspoints[passIndex].isEnable = false
        }

        shiftInfoTemp.shiftPasspoints[passIndex].startPassengerList = []
        shiftInfoTemp.shiftPasspoints[passIndex].arrivePassengerList = []
        for(let reserveIndex = 0; reserveIndex < shiftInfoTemp.shiftReservationInfos.length; reserveIndex++){
          // 停留所ごとの乗車リストを作成
          if(shiftInfoTemp.shiftPasspoints[passIndex].routeType != 1 
          && shiftInfoTemp.shiftPasspoints[passIndex].stationId === shiftInfoTemp.shiftReservationInfos[reserveIndex].startStationId
          && shiftInfoTemp.shiftReservationInfos[reserveIndex].pickupFlag === '1'){
            shiftInfoTemp.shiftPasspoints[passIndex].startPassengerList.push(shiftInfoTemp.shiftReservationInfos[reserveIndex].reserveId)
            shiftInfoTemp.shiftPasspoints[passIndex].isEnable = true
          }else if(shiftInfoTemp.shiftPasspoints[passIndex].routeType != 1 
          && shiftInfoTemp.shiftPasspoints[passIndex].stationId === shiftInfoTemp.shiftReservationInfos[reserveIndex].arriveStationId
          && shiftInfoTemp.shiftReservationInfos[reserveIndex].pickupFlag === '1'){
            // 停留所ごとの降車リストを作成
            shiftInfoTemp.shiftPasspoints[passIndex].arrivePassengerList.push(shiftInfoTemp.shiftReservationInfos[reserveIndex].reserveId)
            shiftInfoTemp.shiftPasspoints[passIndex].isEnable = true
          }
          // 自宅の場合 乗客の名前を停留所名にセット
          // 住所もセット
          if(shiftInfoTemp.shiftPasspoints[passIndex].routeType == 1){
            if(shiftInfoTemp.shiftPasspoints[passIndex].reserveId === shiftInfoTemp.shiftReservationInfos[reserveIndex].reserveId){
              shiftInfoTemp.shiftPasspoints[passIndex].stationName = shiftInfoTemp.shiftReservationInfos[reserveIndex].lastName + " " + shiftInfoTemp.shiftReservationInfos[reserveIndex].firstName
              shiftInfoTemp.shiftPasspoints[passIndex].stationLat = shiftInfoTemp.shiftReservationInfos[reserveIndex].homeLat
              shiftInfoTemp.shiftPasspoints[passIndex].stationLng = shiftInfoTemp.shiftReservationInfos[reserveIndex].homeLng
              shiftInfoTemp.shiftPasspoints[passIndex].address = shiftInfoTemp.shiftReservationInfos[reserveIndex].homeAddress
              shiftInfoTemp.shiftPasspoints[passIndex].stationId = shiftInfoTemp.shiftReservationInfos[reserveIndex].reserveId
              shiftInfoTemp.shiftPasspoints[passIndex].reserveId = shiftInfoTemp.shiftReservationInfos[reserveIndex].reserveId

              // 予定時刻格納 自宅用
              shiftInfoTemp.shiftPasspoints[passIndex].estimateTime = shiftInfoTemp.shiftReservationInfos[reserveIndex].arriveEstimateTime

              if(shiftInfoTemp.shiftReservationInfos[reserveIndex].pickupFlag === '1'){
                // 帰りなら降車リストに追加
                if(shiftInfoTemp.shiftFlag === 1){
                  shiftInfoTemp.shiftPasspoints[passIndex].arrivePassengerList.push(shiftInfoTemp.shiftReservationInfos[reserveIndex].reserveId)
                  shiftInfoTemp.shiftPasspoints[passIndex].isEnable = true
                }else{
                  // 行きなら乗車リストに追加
                  shiftInfoTemp.shiftPasspoints[passIndex].startPassengerList.push(shiftInfoTemp.shiftReservationInfos[reserveIndex].reserveId)
                  shiftInfoTemp.shiftPasspoints[passIndex].isEnable = true
                }
              }
            }
          }
        }

        // 予定時刻格納 自宅以外
        if(shiftInfoTemp.shiftPasspoints[passIndex].routeType != 1){
          if(shiftInfoTemp.shiftPasspoints[passIndex].startEstimateTime != null && shiftInfoTemp.shiftPasspoints[passIndex].startEstimateTime != ''){
            shiftInfoTemp.shiftPasspoints[passIndex].estimateTime = shiftInfoTemp.shiftPasspoints[passIndex].startEstimateTime
          }else{
            shiftInfoTemp.shiftPasspoints[passIndex].estimateTime = shiftInfoTemp.shiftPasspoints[passIndex].arriveEstimateTime
          }
        }

        // 到着時刻を時と分にわける
        shiftInfoTemp.shiftPasspoints[passIndex].actualTimeHour = this.getHourAsNum(shiftInfoTemp.shiftPasspoints[passIndex].arriveActualTime)
        shiftInfoTemp.shiftPasspoints[passIndex].actualTimeMin = this.getMinAsNum(shiftInfoTemp.shiftPasspoints[passIndex].arriveActualTime)

        // 自宅の場合 自宅カウントをセット
        if(shiftInfoTemp.shiftPasspoints[passIndex].routeType == 1){
          shiftInfoTemp.shiftPasspoints[passIndex].homeIndex = homeIndex
          homeIndex++
        }

        // 訂正用フラグの初期値をセット
        shiftInfoTemp.shiftPasspoints[passIndex].newPointFlag = 0
        shiftInfoTemp.shiftPasspoints[passIndex].deletePointFlag = 0
      }

      // 乗車フラグをboolに変換 受け取るデータが文字列でそのままでは使いづらいので
      for(let reserveIndex = 0; reserveIndex < shiftInfoTemp.shiftReservationInfos.length; reserveIndex++){
        let pickupStatus = shiftInfoTemp.shiftReservationInfos[reserveIndex].pickupFlag
        if(pickupStatus === '1'){
          // 乗車あり
          shiftInfoTemp.shiftReservationInfos[reserveIndex].pickupFlag = true
        }else if(pickupStatus === '0'){
          // 乗車なし
          shiftInfoTemp.shiftReservationInfos[reserveIndex].pickupFlag = false
        }else{
          // 未確定
          shiftInfoTemp.shiftReservationInfos[reserveIndex].pickupFlag = null
        }
      }
    },
    // 待機時間入力時処理
    changeWaitSumTime(){
      console.log("changeWaitSumTime")
      this.waitTimeError = false
      if(this.shiftInfo.waitSumTime === null || this.shiftInfo.waitSumTime === ""){
        this.shiftInfo.waitSumTime = 0
      }else{
        if(!this.actualTimeError1 && !this.actualTimeError2 && !this.actualTimeError3
        && this.shiftInfo.businessStartTime != null && !this.businessStartTimeError 
        && this.shiftInfo.moveStartTime != null && !this.moveStartTimeError){
          let waitTimeLimit = 0
          waitTimeLimit = this.hourMinToMin(this.shiftInfo.moveStartTime)- this.hourMinToMin(this.shiftInfo.businessStartTime)

          if( waitTimeLimit < this.shiftInfo.waitSumTime){
            this.waitTimeError = true
          }
        }
      }
    },
    // 時刻チェック
    async changeActualTime(){
      console.log("changeActualTime")
      // エラーフラグを取り消し
      this.actualTimeError1 = false
      this.actualTimeError2 = false
      this.actualTimeError3 = false

      // yyyyMMddHHmmssの形で日付を作成
      for(let i = 0; i < this.shiftInfo.shiftPasspoints.length; i++){
        if(this.shiftInfo.shiftPasspoints[i].actualTimeHour !== null && this.shiftInfo.shiftPasspoints[i].actualTimeHour !== ""
        && this.shiftInfo.shiftPasspoints[i].actualTimeMin !== null && this.shiftInfo.shiftPasspoints[i].actualTimeMin !== ""){
          this.shiftInfo.shiftPasspoints[i].arriveActualTime = this.shiftInfo.moveShiftTime + this.addPreZero(this.shiftInfo.shiftPasspoints[i].actualTimeHour) + this.addPreZero(this.shiftInfo.shiftPasspoints[i].actualTimeMin) + "00"
        }else{
          this.shiftInfo.shiftPasspoints[i].arriveActualTime = null
        }
      }

      // shiftPasspointsをsortNoでソート・アクティブフラグが立っているもののみ取り出す
      let activePasspoints = []
      for(let sortNo = 1; sortNo <= this.shiftInfo.shiftPasspoints.length; sortNo++){
        for(let index = 0; index < this.shiftInfo.shiftPasspoints.length; index++){
          if(this.shiftInfo.shiftPasspoints[index].sortNo === sortNo && this.shiftInfo.shiftPasspoints[index].isEnable){
            let activePasspoint = {}
            activePasspoint.sortNo = sortNo
            activePasspoint.stationId = this.shiftInfo.shiftPasspoints[index].stationId
            activePasspoint.arriveActualTime = this.shiftInfo.shiftPasspoints[index].arriveActualTime 
            activePasspoints.push(activePasspoint)
          }
        }
      }

      // エラーチェック2 未入力
      // アクティブな停留所の時刻が未入力ならエラー
      for(let i = 0; i < this.shiftInfo.shiftPasspoints.length; i++){
        if(this.shiftInfo.shiftPasspoints[i].isEnable && this.shiftInfo.shiftPasspoints[i].arriveActualTime === null){
          this.actualTimeError2 = true
          return false
        }
        // v-validateによるエラーチェック
        if(this.$validator.errors.has('actualTimeHour' + i) || this.$validator.errors.has('actualTimeMin' + i)){
          this.actualTimeError2 = true
          return false
        }
      }

      // エラーチェック1 逆行
      // 時刻が逆行していたらエラーフラグを立てる
      // 同じ時刻は許容する
      for(let i = 0; i < activePasspoints.length - 1; i++){
        let time1 = activePasspoints[i].arriveActualTime
        let time2 = activePasspoints[i + 1].arriveActualTime
        if(Number(time1.substr(0,12)) > Number(time2.substr(0,12))){
          this.actualTimeError1 = true
        }
      }

      // エラーチェック3 終了時刻は開始時刻より後でなければならない
      if(Number(activePasspoints[0].arriveActualTime.substr(0,12)) >= Number(activePasspoints[activePasspoints.length-1].arriveActualTime.substr(0,12))){
        this.actualTimeError3 = true
      }

      // 車両とドライバーのスケジュール重複チェックを実施
      this.driverError = await this.checkDriverSchedule()
      this.vehicleError = await this.checkVehicleSchedule()
      
      this.checkBusinessStartTime()
      this.checkMoveStartTime()
      // 待機時間をチェック
      this.changeWaitSumTime()
      // 描画を更新
      this.shiftInfo.shiftPasspoints.splice(0,this.shiftInfo.shiftPasspoints)
    },
    // 業務開始時刻変更時処理
    changeBusinessStartTime(){
      if(this.shiftInfo.businessStartTimeHour !== null && this.shiftInfo.businessStartTimeHour !== ""
      && this.shiftInfo.businessStartTimeMin !== null && this.shiftInfo.businessStartTimeMin !== ""){
        this.shiftInfo.businessStartTime = this.shiftInfo.moveShiftTime + this.addPreZero(this.shiftInfo.businessStartTimeHour) + this.addPreZero(this.shiftInfo.businessStartTimeMin) + "00"
        if(this.shiftInfo.shiftPasspoints[0].officeFlag === 1){
          this.shiftInfo.shiftPasspoints[0].actualTimeHour = this.shiftInfo.businessStartTimeHour
          this.shiftInfo.shiftPasspoints[0].actualTimeMin = this.shiftInfo.businessStartTimeMin
          this.shiftInfo.shiftPasspoints[0].arriveActualTime = this.shiftInfo.businessStartTime
        }
      }
      this.checkBusinessStartTime()
      this.checkMoveStartTime()
      // 待機時間をチェック
      this.changeWaitSumTime()
    },
    checkBusinessStartTime(){
      console.log("checkBusinessStartTime")
      if(this.shiftInfo.businessStartTime !== null && this.shiftInfo.moveStartTime !== null
        && this.shiftInfo.businessStartTime !== "" && this.shiftInfo.moveStartTime !== ""){
        this.businessStartTimeError = false
        if(Number(this.shiftInfo.businessStartTime.substr(0,12)) > Number(this.shiftInfo.moveStartTime.substr(0,12))){
          this.businessStartTimeError = true
        }
      }
    },
    // 運行開始時刻変更時処理
    changeMoveStartTime(){
      console.log("changeMoveStartTime")
      if(this.shiftInfo.moveStartTimeHour !== null && this.shiftInfo.moveStartTimeHour !== ""
      && this.shiftInfo.moveStartTimeMin !== null && this.shiftInfo.moveStartTimeMin !== ""){
        this.shiftInfo.moveStartTime = this.shiftInfo.moveShiftTime + this.addPreZero(this.shiftInfo.moveStartTimeHour) + this.addPreZero(this.shiftInfo.moveStartTimeMin) + "00"
      }

      this.checkBusinessStartTime()
      this.checkMoveStartTime()
      // 待機時間をチェック
      this.changeWaitSumTime()
    },

    checkMoveStartTime(){
      console.log("checkMoveStartTime")
      if(this.shiftInfo.moveStartTime !== null && this.shiftInfo.moveStartTime !== ""){
        this.moveStartTimeError = false
        // 出発地が事務所ではないときは最初の停留所と比較
        if(this.shiftInfo.shiftPasspoints[0].officeFlag === 0){
          if(his.shiftInfo.shiftPasspoints[0].arriveActualTime !== null && his.shiftInfo.shiftPasspoints[0].arriveActualTime !== ""){
            if(Number(this.shiftInfo.moveStartTime.substr(0,12)) > Number(this.shiftInfo.shiftPasspoints[0].arriveActualTime.substr(0,12))){
              this.moveStartTimeError = true
            }
          }
        }else{
          // 出発地が事務所のときは事務所の次の有効な停留所と比較
          let targetPointTime
          for(let i = 0; i < this.shiftInfo.shiftPasspoints.length; i++){
            if(i !== 0 && this.shiftInfo.shiftPasspoints[i].isEnable){
              targetPointTime = this.shiftInfo.shiftPasspoints[i].arriveActualTime
              break;
            }
          }
          console.log(targetPointTime)
          if(targetPointTime !== null && targetPointTime !== ""){
            if(Number(this.shiftInfo.moveStartTime.substr(0,12)) > Number(targetPointTime.substr(0,12))){
              this.moveStartTimeError = true
            }
          }
        }
      }
    },
    // メーター変更時処理 走行距離算出
    changeMeter(){
      console.log("changeMeter")
      if($.isNumeric(this.shiftInfo.returnDistance) && $.isNumeric(this.shiftInfo.startDistance)){
        if(this.shiftInfo.startDistance < this.shiftInfo.returnDistance){
          this.distanceError = false
        }else{
          this.distanceError = true
        }
        this.shiftInfo.totalDistance = this.shiftInfo.returnDistance - this.shiftInfo.startDistance
      }else{
        this.distanceError = false
        this.shiftInfo.totalDistance = null
      }
    },
    // 乗車フラグ切り替え時処理
    changePickupFlag(reserveId, pickupFlag){
      console.log("changePickupFlag reserveId:"+reserveId+" pickupFlag:"+pickupFlag)

      // 予約情報をオリジナルの情報に戻す
      let arriveStationIdOriginal = ""
      let arrivePlaceTypeOriginal = 0
      let startStationIdOriginal = ""
      let startPlaceTypeOriginal = 0
      let passengerNumberOriginal = 0
      let passengerCostOriginal = 0
      let startStationId = ""
      let arriveStationId = ""
      for(let i = 0; i < this.shiftInfoOriginal.shiftReservationInfos.length; i++){
        if(this.shiftInfoOriginal.shiftReservationInfos[i].reserveId === reserveId){
          startStationIdOriginal = this.shiftInfoOriginal.shiftReservationInfos[i].startStationId
          startPlaceTypeOriginal = this.shiftInfoOriginal.shiftReservationInfos[i].startPlaceType
          arriveStationIdOriginal = this.shiftInfoOriginal.shiftReservationInfos[i].arriveStationId
          arrivePlaceTypeOriginal = this.shiftInfoOriginal.shiftReservationInfos[i].arrivePlaceType
          passengerNumberOriginal = this.shiftInfoOriginal.shiftReservationInfos[i].passengerNumber
          passengerCostOriginal = this.shiftInfoOriginal.shiftReservationInfos[i].passengerCost
        }
      }
        for(let i = 0; i < this.shiftInfo.shiftReservationInfos.length; i++){
          if(this.shiftInfo.shiftReservationInfos[i].reserveId === reserveId){
            // 元の乗車場所が自宅ではない場合
            if(startPlaceTypeOriginal === 2){
              startStationId = startStationIdOriginal
            }else{
              startStationId = reserveId
            }
            // 元の降車場所が自宅ではない場合
            if(arrivePlaceTypeOriginal === 2){
              arriveStationId = arriveStationIdOriginal
            }else{
              arriveStationId = reserveId
            }
            this.shiftInfo.shiftReservationInfos[i].startStationId = startStationId
            this.shiftInfo.shiftReservationInfos[i].startPlaceType = startPlaceTypeOriginal
            this.shiftInfo.shiftReservationInfos[i].arriveStationId = arriveStationId
            this.shiftInfo.shiftReservationInfos[i].arrivePlaceType = arrivePlaceTypeOriginal
            this.shiftInfo.shiftReservationInfos[i].passengerNumber = passengerNumberOriginal
            this.shiftInfo.shiftReservationInfos[i].passengerCost = passengerCostOriginal
          }
        }
      if(!pickupFlag){
        this.changeStartStation(reserveId, "", "")
        this.changeArriveStation(reserveId, "", "")
      }else{
        this.changeStartStation(reserveId, startStationId, "")
        this.changeArriveStation(reserveId, arriveStationId, "")
      }
      this.changePassengerNumber()
      this.changeActualTime()
    },
    // 乗員数変更時処理
    changePassengerNumber(){
      console.log("changePassengerNumber")
      // 現在選択している車両の定員を取得
      let capacity = 0
      for(let i = 0; i < this.vehicleList.length; i++){
        if(this.vehicleList[i].vehicleId === this.shiftInfo.vehicleId){
          capacity = this.vehicleList[i].passengerNumber
        }
      }
      // 現在入力されている乗員の合計を取得
      let number = 0
      this.passengerNumberError2 = false
      for(let i = 0; i < this.shiftInfo.shiftReservationInfos.length; i++){
        this.shiftInfo.shiftReservationInfos[i].passengerNumberError2 = false

        if(this.shiftInfo.shiftReservationInfos[i].pickupFlag
        && $.isNumeric(this.shiftInfo.shiftReservationInfos[i].passengerNumber)){
          number += Number(this.shiftInfo.shiftReservationInfos[i].passengerNumber)

          // 数値チェック 1以上
          if(this.shiftInfo.shiftReservationInfos[i].passengerNumber <= 0){
            this.shiftInfo.shiftReservationInfos[i].passengerNumberError2 = true
            this.passengerNumberError2 = true
          }
        }
      }

      if(capacity < number){
        this.passengerNumberError1 = true
      }else{
        this.passengerNumberError1 = false
      }
      // 描画を更新
      this.shiftInfo.shiftPasspoints.splice(0,this.shiftInfo.shiftPasspoints)
    },
    // 乗車場所変更時処理
    changeStartStation(reserveId, stationId, key){
      console.log("changeStartStation " + reserveId + " " + stationId + " " + key)      
      // 乗車場所より前の位置の降車場所は選択させない
      for(let passIndex = 0; passIndex < this.shiftInfo.shiftPasspoints.length; passIndex++){
        for(let reserveIndex = 0; reserveIndex < this.shiftInfo.shiftReservationInfos.length; reserveIndex++){
          if(this.shiftInfo.shiftPasspoints[passIndex].stationId === this.shiftInfo.shiftReservationInfos[reserveIndex].startStationId){
            this.shiftInfo.shiftReservationInfos[reserveIndex].startStationNumber = this.shiftInfo.shiftPasspoints[passIndex].sortNo
          }
        }
      }
      // 予約者の乗車場所タイプを更新
      if(key != null && key !== ""){
        if(reserveId === stationId){
          // 自宅
          this.shiftInfo.shiftReservationInfos[key].startPlaceType = 1
        }else{
          // 自宅じゃない
          this.shiftInfo.shiftReservationInfos[key].startPlaceType = 2
        }
      }
      // 一旦すべての停留所リストの乗車者リストから操作した乗車者を取り除く
      for(let passIndex = 0; passIndex < this.shiftInfo.shiftPasspoints.length; passIndex++){
        let pos = this.shiftInfo.shiftPasspoints[passIndex].startPassengerList.indexOf(reserveId)
        if(-1 < pos){
          this.shiftInfo.shiftPasspoints[passIndex].startPassengerList.splice(pos, 1)
        }
      }
      // 停留所リストのうち選択した停留所IDと一致するところの乗車者リストに操作した乗車者を追加する
      if(stationId != null && stationId !== ""){
        for(let passIndex = 0; passIndex < this.shiftInfo.shiftPasspoints.length; passIndex++){
          if(this.shiftInfo.shiftPasspoints[passIndex].stationId === stationId){
            this.shiftInfo.shiftPasspoints[passIndex].startPassengerList.push(reserveId)
          }
        }
      }
      this.checkEnablePasspoint()
    },
    // 降車場所変更時処理
    changeArriveStation(reserveId, stationId, key){
      console.log("changeArriveStation " + reserveId + " " + stationId)
      // 予約者の降車場所タイプを更新
      if(key != null && key !== ""){
        if(reserveId === stationId){
          // 自宅
          this.shiftInfo.shiftReservationInfos[key].arrivePlaceType = 1
        }else{
          // 自宅じゃない
          this.shiftInfo.shiftReservationInfos[key].arrivePlaceType = 2
        }
      }

      // 一旦すべての停留所リストの降車者リストから操作した降車者を取り除く
      for(let passIndex = 0; passIndex < this.shiftInfo.shiftPasspoints.length; passIndex++){
        let pos = this.shiftInfo.shiftPasspoints[passIndex].arrivePassengerList.indexOf(reserveId)
        if(-1 < pos){
          this.shiftInfo.shiftPasspoints[passIndex].arrivePassengerList.splice(pos, 1)
        }
      }
      // 停留所リストのうち選択した停留所IDと一致するところの降車者リストに操作した降車者を追加する
      if(stationId != null && stationId !== ""){
        for(let passIndex = 0; passIndex < this.shiftInfo.shiftPasspoints.length; passIndex++){
          if(this.shiftInfo.shiftPasspoints[passIndex].stationId === stationId){
            this.shiftInfo.shiftPasspoints[passIndex].arrivePassengerList.push(reserveId)
          }
        }
      }
      this.checkEnablePasspoint()
    },
    checkEnablePasspoint(){
      // すべての有効フラグを更新
      for(let passIndex = 0; passIndex < this.shiftInfo.shiftPasspoints.length; passIndex++){
        this.shiftInfo.shiftPasspoints[passIndex].isEnable = false
        // 最初と最後の停留所は有効
        if(passIndex === 0
        || passIndex === this.shiftInfo.shiftPasspoints.length - 1){
          this.shiftInfo.shiftPasspoints[passIndex].isEnable = true
        }

        // 利用者がいる
        if(0 < this.shiftInfo.shiftPasspoints[passIndex].startPassengerList.length){
          this.shiftInfo.shiftPasspoints[passIndex].isEnable = true
        }else if(0 < this.shiftInfo.shiftPasspoints[passIndex].arrivePassengerList.length){
          this.shiftInfo.shiftPasspoints[passIndex].isEnable = true
        }

        // 無効な停留所は到着時刻をnullにする
        if(!this.shiftInfo.shiftPasspoints[passIndex].isEnable){
          this.shiftInfo.shiftPasspoints[passIndex].arriveActualTime = null
          this.shiftInfo.shiftPasspoints[passIndex].actualTimeHour = null
          this.shiftInfo.shiftPasspoints[passIndex].actualTimeMin = null
        }
      }

      this.changeActualTime()
      // 表示用index更新
      this.updateFrontIndex()
    },
    // フォームの停留所のインデックスを更新
    updateFrontIndex(){
      // 表示用index作成
      let passCount = 0;
      let homeCount = 0;
      for(let i = 0; i < this.shiftInfo.shiftPasspoints.length; i++){
        if(this.shiftInfo.shiftPasspoints[i].routeType == 0){
          passCount++
          this.shiftInfo.shiftPasspoints[i].frontIndex = passCount
        }else if(this.shiftInfo.shiftPasspoints[i].routeType == 1 && this.shiftInfo.shiftPasspoints[i].isEnable){
          homeCount++
          this.shiftInfo.shiftPasspoints[i].frontIndex = homeCount
        }
      }
    },
    // ドライバーと車両の事業者が一致しているかチェック
    checkTransportId(){
      console.log("checkTransportId")
      this.transportIdError = false
      if(this.shiftInfo.transportKind == 1){
        let driverTransportId
        let vehicleTransportId
        for(let i = 0; i < this.driverList.length; i++){
          if(this.driverList[i].uid == this.shiftInfo.driverUid){
            driverTransportId = this.driverList[i].transportId
          }
        }
        for(let i = 0; i < this.vehicleList.length; i++){
          if(this.vehicleList[i].vehicleId == this.shiftInfo.vehicleId){
            vehicleTransportId = this.vehicleList[i].transportId
          }
        }

        if(driverTransportId != vehicleTransportId){
          this.transportIdError = true
        }
      }
      // 描画を更新
      this.shiftInfo.shiftPasspoints.splice(0,this.shiftInfo.shiftPasspoints)
    },
    // マップ弹出场所地图
    showMapModal (passpoint, key) {
      console.log(passpoint)
      passpoint.stationLat = parseFloat(passpoint.stationLat)
      passpoint.stationLng = parseFloat(passpoint.stationLng)
      this.$refs.showMapWindow.mapId = 'home'
      // 图标样式
      let vehiclePoint = {
        lat: passpoint.stationLat,
        lng: passpoint.stationLng,
        icon: mapDropPin
      }
      var centerPoint = {
        lat: passpoint.stationLat,
        lng: passpoint.stationLng
      }
      let addressInfo = ''
      if (passpoint.routeType == 1){
        addressInfo = '経由地' + (passpoint.homeIndex+1) + ': ' + passpoint.stationName
      }else if (key === 0) {
        addressInfo = '出発地: ' + passpoint.stationName
      } else if (key === this.shiftInfoOriginal.shiftPasspoints.length - 1) {
        addressInfo = '終着地: ' + passpoint.stationName
      } else {
        addressInfo = '停留所' + passpoint.routeNo + ': ' + passpoint.stationName
      }
      this.$refs.showMapWindow.mapTitle = addressInfo
      this.$refs.showMapWindow.centerPoint = centerPoint
      this.$refs.showMapWindow.markPosition = vehiclePoint
      this.$refs.showMapWindow.initiGoogleMap()
    },
    async submit(){
      // バリデーション
      this.$validator.validateAll().then( result => {
        if(result) {
          // 基本バリデーション以外のエラーを一通り再チェック
          // 到着時刻
          this.changeActualTime()
          // ドライバーと車両の事業者ID
          this.checkTransportId()
          // 運行距離
          this.changeMeter()
          // 乗員合計
          this.changePassengerNumber()
          if(!this.transportIdError
          && !this.actualTimeError1
          && !this.actualTimeError2
          && !this.actualTimeError3
          && !this.waitTimeError
          && !this.businessStartTimeError
          && !this.moveStartTimeError
          && !this.distanceError
          && !this.driverError
          && !this.vehicleError
          && !this.passengerNumberError1
          && !this.passengerNumberError2){

            // 送信用便情報作成
            let correctShiftInfoModel = {}
            correctShiftInfoModel.shiftId = this.shiftInfo.shiftId
            correctShiftInfoModel.vehicleId = this.shiftInfo.vehicleId
            correctShiftInfoModel.driverUid = this.shiftInfo.driverUid
            correctShiftInfoModel.correctNote = this.shiftInfo.correctNote
            correctShiftInfoModel.startDistance = this.shiftInfo.startDistance
            correctShiftInfoModel.returnDistance = this.shiftInfo.returnDistance
            correctShiftInfoModel.totalDistance = this.shiftInfo.totalDistance
            correctShiftInfoModel.waitSumTime = this.shiftInfo.waitSumTime
            correctShiftInfoModel.businessStartTime = this.shiftInfo.businessStartTime
            correctShiftInfoModel.moveStartTime = this.shiftInfo.moveStartTime

            correctShiftInfoModel.correctShiftPasspointList = []
            correctShiftInfoModel.correctShiftReservationList = []

            // 経由地情報リスト作成
            for(let i = 0; i < this.shiftInfo.shiftPasspoints.length; i++){
              let correctShiftpasspoint = {}
              let push = true
              correctShiftpasspoint.routeNo = this.shiftInfo.shiftPasspoints[i].routeNo
              correctShiftpasspoint.routeType = this.shiftInfo.shiftPasspoints[i].routeType
              if(correctShiftpasspoint.routeType == "0"){
                correctShiftpasspoint.stationId = this.shiftInfo.shiftPasspoints[i].stationId
                correctShiftpasspoint.reserveId = null
                correctShiftpasspoint.newPointFlag = null
                correctShiftpasspoint.deletePointFlag = null
              }else if(correctShiftpasspoint.routeType == "1"){
                correctShiftpasspoint.stationId = null
                correctShiftpasspoint.reserveId = this.shiftInfo.shiftPasspoints[i].reserveId

                // 有効な自宅
                if(this.shiftInfo.shiftPasspoints[i].isEnable){
                  // 新規経由地
                  if(this.shiftInfo.shiftPasspoints[i].newPointFlag === 1){
                    correctShiftpasspoint.newPointFlag = 1
                    correctShiftpasspoint.deletePointFlag = 0
                  }else{
                    correctShiftpasspoint.newPointFlag = 0
                    correctShiftpasspoint.deletePointFlag = 0
                  }
                }else{
                  // 新規経由地
                  if(this.shiftInfo.shiftPasspoints[i].newPointFlag === 1){
                    push = false
                  }else{
                    // 無効な自宅はdeletePointFlag = 1にして削除を依頼する
                    correctShiftpasspoint.newPointFlag = 0
                    correctShiftpasspoint.deletePointFlag = 1
                    console.log(this.shiftInfo.shiftPasspoints[i].stationId)
                    console.log("無効な自宅を削除")
                    // 予約デフォルトの乗車場所降車場所に選ばれている場合は削除しない
                    for(let reserveIndex = 0; reserveIndex < this.shiftInfoOriginal.shiftReservationInfos.length; reserveIndex++){
                      if(this.shiftInfo.shiftPasspoints[i].stationId === this.shiftInfoOriginal.shiftReservationInfos[reserveIndex].startStationId
                      ||this.shiftInfo.shiftPasspoints[i].stationId === this.shiftInfoOriginal.shiftReservationInfos[reserveIndex].ariiveStationId){
                        console.log("削除キャンセル")
                        correctShiftpasspoint.deletePointFlag = 0
                      }
                    }
                  }
                }
              }else{
                console.log("エラー")
                return
              }
              // 無効な停留所の時刻はすべてnullとする
              if(!this.shiftInfo.shiftPasspoints[i].isEnable || this.shiftInfo.shiftPasspoints[i].arriveActualTime===null){
                correctShiftpasspoint.displayFlag = 0
                correctShiftpasspoint.arriveActualTime = null
              }else{
                correctShiftpasspoint.displayFlag = 1
                correctShiftpasspoint.arriveActualTime = this.shiftInfo.shiftPasspoints[i].arriveActualTime

              }
              if(push){
                correctShiftpasspoint.sortNo = i + 1
                correctShiftInfoModel.correctShiftPasspointList.push(correctShiftpasspoint)
              }
            }
            
            // 予約情報リスト作成
            for(let i = 0; i < this.shiftInfo.shiftReservationInfos.length; i++){
              let correctShiftReservation = {}
              correctShiftReservation.reserveId = this.shiftInfo.shiftReservationInfos[i].reserveId
              correctShiftReservation.passengerNumber = $.isNumeric(this.shiftInfo.shiftReservationInfos[i].passengerNumber)?parseInt(this.shiftInfo.shiftReservationInfos[i].passengerNumber):0
              correctShiftReservation.startPlaceType = this.shiftInfo.shiftReservationInfos[i].startPlaceType
              correctShiftReservation.startStationId = this.shiftInfo.shiftReservationInfos[i].startStationId === ""?null:this.shiftInfo.shiftReservationInfos[i].startStationId
              correctShiftReservation.arrivePlaceType = this.shiftInfo.shiftReservationInfos[i].arrivePlaceType
              correctShiftReservation.arriveStationId = this.shiftInfo.shiftReservationInfos[i].arriveStationId === ""?null:this.shiftInfo.shiftReservationInfos[i].arriveStationId
              correctShiftReservation.passengerCost = $.isNumeric(this.shiftInfo.shiftReservationInfos[i].passengerCost)?parseInt(this.shiftInfo.shiftReservationInfos[i].passengerCost):0
              // pickupFlagを文字列に戻して投げる '0':乗車あり '1':乗車なし 
              if(this.shiftInfo.shiftReservationInfos[i].pickupFlag === true){
                correctShiftReservation.pickupFlag = "1"
              }else if(this.shiftInfo.shiftReservationInfos[i].pickupFlag === false){
                correctShiftReservation.pickupFlag = "0"
              }else{
                correctShiftReservation.pickupFlag = null
              }
              correctShiftInfoModel.correctShiftReservationList.push(correctShiftReservation)
            }
            console.log(correctShiftInfoModel)

            this.$axios.post('shift/saveCorrectShiftInfo', correctShiftInfoModel).then(response => {
              console.log("成功")
              sessionStorage.setItem('fromEditMovementWork', 'fromEditMovementWork')
              sessionStorage.setItem('shiftId', this.shiftInfo.shiftId)
              this.$router.go(-1)
            }).catch(function (error) {
              console.log(error)
            })
          }else{
            console.log("エラーあり")
            console.log("transportIdError : " + this.transportIdError)
            console.log("driverError : " + this.driverError)
            console.log("vehicleError : " + this.vehicleError)
            console.log("actualTimeError1 : " + this.actualTimeError1)
            console.log("actualTimeError2 : " + this.actualTimeError2)
            console.log("distanceError : " + this.distanceError)
            console.log("passengerNumberError1 : " + this.passengerNumberError1)
            console.log("passengerNumberError2 : " + this.passengerNumberError2)
          }
        }else{
          console.log("エラーあり")
        }
      })
    },
    cancel(){
      this.$router.go(-1)
    }
  }
}
</script>
<template>
<main-layout>
  <div class="common-width title-area">
    <div class="title-title" @click="debugLog()">
      運行実績の訂正
    </div>
  </div>
  <div class="section-wrapper">
    <section class="common-width shift-area">
      <div class="shift-caption">
        編集前の実績
      </div>
      <table>
        <tbody>
          <tr class="shift-row">
            <td class="shift-title">
              便名
            </td>
            <td class="shift-data-text" colspan="5">
              {{shiftInfoOriginal.title}}
            </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              便ID
            </td>
            <td class="shift-data-text" colspan="5">
              {{shiftInfoOriginal.shiftId}}
            </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              ルート
            </td>
            <td class="shift-data-text" colspan="5">
              {{shiftInfoOriginal.routeName}}
            </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              行き/帰り
            </td>
            <td class="shift-data-text" colspan="5">
              <span v-if="shiftInfoOriginal.shiftFlag === 1">帰り</span>
              <span v-else>行き</span>
            </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              地区フィルター
            </td>
            <td class="shift-data-text" colspan="5">
              {{shiftInfoOriginal.areaName}}
            </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              運行日
            </td>
            <td class="shift-data-text shift-col-3" colspan="3">
              {{getYearWeek(shiftInfoOriginal.moveShiftTime)}}
            </td>
            <td class="shift-title">
              待機時間
            </td>
            <td class="shift-data-num shift-col-1">
              {{shiftInfoOriginal.waitSumTime}}分
            </td>
          </tr>
          <tr class="shift-row" v-for="(passpoint, key) in shiftInfoOriginal.shiftPasspoints" :key="key"
            :class='[!passpoint.isEnable?"shift-disable":""]'>
            <td class="shift-title">
              <span v-if="passpoint.routeType == 1">経由地{{passpoint.frontIndex}}</span>
              <span v-else-if="key == 0">出発地</span>
              <span v-else-if="key == shiftInfoOriginal.shiftPasspoints.length - 1">到着地</span>
              <span v-else>停留所{{passpoint.frontIndex - 1}}</span>
            </td>
            <td class="shift-data-text shift-col-station">
              <span v-show="!passpoint.isEnable">↓</span>
              <span v-if="passpoint.routeType == 1">{{passpoint.address}}</span>
              <span v-else>{{passpoint.stationName}}</span>
              <a href="#modal-container-staySave"  data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                <button class="shift-map" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;"
                @click="showMapModal(passpoint,key)">
                  マップ
                </button>
              </a>
            </td>
            <td class='shift-title'>
              <span v-if="key == 0">出発予定時間</span>
              <span v-else>到着予定時間</span>
            </td>
            <td class="shift-data-num shift-col-1">
              {{getHourMin(passpoint.estimateTime)}}
            </td>
            <td class='shift-title'>
              <span v-if="key == 0">出発時間</span>
              <span v-else>到着時間</span>
            </td>
            <td class="shift-data-num shift-col-1">
              <span v-if="passpoint.isEnable===true && shiftInfoOriginal.coercionStopFlag === 0">
                {{getHourMin(passpoint.arriveActualTime)}}
              </span>
              <span v-else>↓</span>
            </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              利用料金
            </td>
            <td class="shift-data-cost" colspan="1">
              <span v-show="shiftInfoOriginal.shiftCost!=null && shiftInfoOriginal.shiftCost!==''">{{shiftInfoOriginal.shiftCost}}円</span>
            </td>
            <td class="shift-title" colspan="1">
              強制終了日時
            </td>
            <td class="shift-data-coercion" colspan="3">
              {{getYearWeek(shiftInfoOriginal.coercionStopTime)}} {{getHourMin(shiftInfoOriginal.coercionStopTime)}}
            </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              フリガナ
            </td>
            <td class="shift-data-text" colspan="5">
              {{shiftInfoOriginal.driverNameKana}}
            </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              ドライバー
            </td>
            <td class="shift-data-text" colspan="5">
              {{shiftInfoOriginal.driverName}}
            </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              車両
            </td>
            <td class="shift-data-text" colspan="5">
              {{shiftInfoOriginal.vehicleName}}&nbsp;&nbsp;&nbsp;ID:{{shiftInfoOriginal.displayVehicleId}}&nbsp;&nbsp;&nbsp;定員{{shiftInfoOriginal.passengerNumber}}名
            </td>
          </tr>
          <tr class="shift-row">
              <td class="shift-title">
                出発メーター
              </td>
              <td class="shift-col-meter" colspan="5">
                <div class="shift-meter-data">
                {{(shiftInfoOriginal.startDistance!=null)?(shiftInfoOriginal.startDistance).toLocaleString():""}}km
                </div>
                <div class="shift-meter-title">
                  到着メーター
                </div>
                <div class="shift-meter-data">
                  {{(shiftInfoOriginal.returnDistance!=null)?(shiftInfoOriginal.returnDistance).toLocaleString():""}}km
                </div>
                <div class="shift-meter-title">
                  走行距離
                </div>
                <div class="shift-meter-data">
                  {{(shiftInfoOriginal.totalDistance!=null)?(shiftInfoOriginal.totalDistance).toLocaleString():""}}km
                </div>
              </td>
          </tr>
          <tr class="shift-row">
            <td class="shift-title">
              コメント
            </td>
            <td class="shift-data-text" colspan="5">
              {{shiftInfoOriginal.comment}}
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="common-width passenger-area">
      <table>
        <tbody>
          <tr class="passenger-row"
            v-for='(shiftReservation,key) in shiftInfoOriginal.shiftReservationInfos' :key="key">
            <td class="passenger-title"
              style="min-width: 60px;">
              乗客
            </td>
            <td class="passenger-data"
              style="min-width: 160px;">
              {{shiftReservation.lastName}} {{shiftReservation.firstName}}
            </td>
            <td class="passenger-title"
              style="min-width: 60px;">
              乗車
            </td>
            <td class="passenger-data"
              style="min-width: 90px;">
              <span v-if="shiftReservation.pickupFlag === true">あり</span>
              <span v-else-if="shiftReservation.pickupFlag === false">なし</span>
              <span v-else>未確定</span>

            </td>
            <td class="passenger-title"
              style="min-width: 100px;">
              乗車場所
            </td>
            <td class="passenger-data"
                style="min-width: 200px;">
              <div v-if="shiftReservation.startPlaceType === 1">{{shiftReservation.homeAddress}}</div>
              <div v-else>{{shiftReservation.startStationName}}</div>
            </td>
            <td class="passenger-title"
              style="min-width: 100px;">
              降車場所
            </td>
            <td class="passenger-data"
              style="min-width: 200px;">
              <div>
                <div v-if="shiftReservation.arrivePlaceType === 1">{{shiftReservation.homeAddress}}</div>
                <div v-else>{{shiftReservation.arriveStationName}}</div>
              </div>
            </td>
            <td class="passenger-title"
              style="min-width: 60px;">
              乗員
            </td>
            <td class="passenger-data"
              style="min-width: 60px;">
              {{shiftReservation.passengerNumber}}人
            </td>
            <td class="passenger-title"
              style="min-width: 100px;">
              利用料金
            </td>
            <td class="passenger-data"
              style="min-width: 100px;">
              {{shiftReservation.passengerCost}}円
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="common-width form-area">
      <div class="form-caption">
        実績の編集
      </div>
      <div class="form-pass" v-if="shiftInfo.shiftPasspoints.length > 0">
        <div class="form-pass-table">
          <div class="form-pass-row">
            <div class="form-pass-title" :class="shiftInfo.shiftPasspoints[0].officeFlag === 0?'form-pass-station':''">
              <span>出発地</span>
            </div>
            <div class="form-pass-name" :class="shiftInfo.shiftPasspoints[0].officeFlag === 0?'form-pass-station':''">
              <span>{{shiftInfo.shiftPasspoints[0].stationName}}</span>
            </div>
            <div class="form-pass-title">
              業務開始時刻
            </div>
            <div class="form-pass-time">
              <div class="form-pass-time-select">
                <select class="common-select" v-model="shiftInfo.businessStartTimeHour" @change="changeBusinessStartTime(),changeActualTime()">
                  <option v-for="n in 24" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
                </select>
                時
                <select class="common-select" v-model="shiftInfo.businessStartTimeMin" @change="changeBusinessStartTime(),changeActualTime()">
                  <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
                </select>
                分
              </div>
              <div class="form-pass-time-error"
              v-if="businessStartTimeError">
                時刻の順序が不正です。
              </div>
            </div>
            <div class="form-pass-wait">
              <div>
                <div class="form-pass-title">
                  待機時間
                </div>
                <div class="form-wait-time">
                  <div class="form-wait-input">
                    <input type="text" 
                      v-model="shiftInfo.waitSumTime"
                      name='waitSumTime'
                      v-validate="'numeric'"
                      maxlength="3"
                      @change="changeWaitSumTime()"
                    >分
                  </div>

                </div>
              </div>
              <div class="form-wait-error" v-if="errors.has('waitSumTime')">
                {{ errors.first('waitSumTime') }}
              </div>
              <div class="form-wait-error" v-if="waitTimeError">
                <span v-if="this.shiftInfo.shiftPasspoints[0].officeFlag === 0">
                  業務開始時刻から運行開始時刻までの間で入力してください。
                </span>
                <span v-else>
                  業務開始時刻から運行開始時刻までの間で入力してください。
                </span>
              </div>
            </div>
          </div>
          <div class="form-pass-row">
            <div class="form-pass-title" style="background-color:unset;"></div>
            <div class="form-pass-name" style="background-color:unset;"></div>
            <div class="form-pass-title">
              運行開始時刻
            </div>
            <div class="form-pass-time">
              <div class="form-pass-time-select">
                <select class="common-select" v-model="shiftInfo.moveStartTimeHour" @change="changeMoveStartTime()">
                  <option v-for="n in 24" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
                </select>
                時
                <select class="common-select" v-model="shiftInfo.moveStartTimeMin" @change="changeMoveStartTime()">
                  <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
                </select>
                分
              </div>
              <div class="form-pass-time-error"
              v-if="moveStartTimeError">
                時刻の順序が不正です。
              </div>
            </div>
          </div>
          <div class="form-pass-row"
              v-for="(passpoint, key1) in shiftInfo.shiftPasspoints" :key="key1"
              :class='[!passpoint.isEnable?"form-disable":"",!passpoint.isEnable&&passpoint.newPointFlag===1?"form-pass-hidden":""]'
              v-show="!(passpoint.officeFlag === 1 && key1 === 0)">
            <div class="form-pass-title">
              <span v-if="passpoint.routeType == 1">経由地{{passpoint.frontIndex}}</span>
              <span v-else-if="key1 == 0">出発地</span>
              <span v-else-if="key1 == shiftInfo.shiftPasspoints.length - 1">到着地</span>
              <span v-else>停留所{{passpoint.frontIndex - 1}}</span>
            </div>
            <div class="form-pass-name">
              <span v-show="!passpoint.isEnable">↓</span>
              <span :class="!passpoint.isEnable?'form-pass-disable':''">{{passpoint.stationName}}</span>
            </div>
            <div class="form-pass-title">
              <span v-if="key1 === 0">出発時刻</span>
              <span v-else>到着時刻</span>
            </div>
            <div class="form-pass-time">
              <div class="form-pass-time-select">
                <select class="common-select" v-model="passpoint.actualTimeHour" @change="changeActualTime()" :disabled="!passpoint.isEnable" 
                        v-validate="'required'" :name='`actualTimeHour${key1}`'>
                  <option v-for="n in 24" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
                </select>
                時
                <select class="common-select" v-model="passpoint.actualTimeMin" @change="changeActualTime()" :disabled="!passpoint.isEnable" 
                        v-validate="'required'" :name='`actualTimeMin${key1}`'>
                  <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
                </select>
                分
              </div>
              <div class="form-pass-time-error form-pass-time-error-1"
              v-if="passpoint.estimateTimeError">
                時刻の順序が不正です。
              </div>
              <div class="form-pass-time-error form-pass-time-error-2"
              v-if="key1 == shiftInfo.shiftPasspoints.length - 1 && actualTimeError1">
                時刻の順序が不正です。
              </div>
              <div class="form-pass-time-error form-pass-time-error-3"
              v-if="key1 == shiftInfo.shiftPasspoints.length - 1 && !actualTimeError1 && actualTimeError3">
                終了時刻は開始時刻より<br>後である必要があります。
              </div>
              <div class="form-pass-time-error"
              v-if="(key1 == shiftInfo.shiftPasspoints.length - 1 && actualTimeError2)">
                到着時刻が入力されていません。
              </div>
            </div>
          </div>
        </div>
        <div class="form-other">
          <div class="form-other-row">
            <div class="form-other-title">
              フリガナ
            </div>
            <div class="form-other-data">
              {{shiftInfo.driverNameKana}}
            </div>
          </div>
          <div class="form-other-row">
            <div class="form-other-title">
              ドライバー
            </div>
            <div class="form-other-select">
              <!-- 区域内用 -->
              <select class="common-select"
              v-model="shiftInfo.driverUid"
              v-if="shiftInfo.transportKind==0"
              @change="changeDriver()">
                <option :value="driver.uid" :key="index"  v-for="(driver, index) in driverList" v-show="driver.roleFlag.substring(1, 2) === '1'">
                  {{driver.lastName}}&nbsp;{{driver.firstName}}
                </option>
              </select>
              <!-- 区域外用 -->
              <select class="common-select"
              v-model="shiftInfo.driverUid"
              v-else
              @change="changeDriver()">
                <option :value="driver.uid" :key="index"  v-for="(driver, index) in driverList" v-show="driver.roleFlag.substring(4, 5) === '1'">
                  {{driver.lastName}}&nbsp;{{driver.firstName}} {{driver.transportId}}
                </option>
              </select>
            </div>
          </div>
          <!-- ドライバーエラー行 -->
          <div class="form-other-row" 
              style="margin-top: 4px; height: 20px; min-height: 20px;"
              v-if="driverError">
            <div class="form-other-title" style="opacity: 0">
            </div>
            <div class="form-other-error">
              ドライバーには他の予定があります。別のドライバーを選択するか、時刻を修正してください。
            </div>
          </div>
          <div class="form-other-row">
            <div class="form-other-title">
              車両
            </div>
            <div class="form-other-select">
                  <!-- 区域内用 -->
                  <select class="common-select"
                  v-model="shiftInfo.vehicleId"
                  v-if="shiftInfo.transportKind==0"
                  @change="changeVehicle()">
                  <option :value="vehicle.vehicleId" :key="index"  v-for="(vehicle, index) in vehicleList" v-show="vehicle.transportKind==0">
                    {{vehicle.vehicleName}}&nbsp;&nbsp;&nbsp;&nbsp;{{"ID:"+vehicle.displayVehicleId}}&nbsp;&nbsp;&nbsp;&nbsp;
                    {{"定員"+vehicle.passengerNumber+"名"}}
                  </option>
                  <!-- 区域外用 -->
                  </select>
                  <select class="common-select"
                  v-model="shiftInfo.vehicleId"
                  v-else
                  @change="changeVehicle()">
                  <option :value="vehicle.vehicleId" :key="index"  v-for="(vehicle, index) in vehicleList" v-show="vehicle.transportKind==1">
                    {{vehicle.vehicleName}}&nbsp;&nbsp;&nbsp;&nbsp;{{"ID:"+vehicle.displayVehicleId}}&nbsp;&nbsp;&nbsp;&nbsp;
                    {{"定員"+vehicle.passengerNumber+"名"}} {{vehicle.transportId}}
                  </option>
                  </select>
            </div>
          </div>
          <!-- 車両エラー行 -->
          <div class="form-other-row" 
              style="margin-top: 4px; height: 20px; min-height: 20px;"
              v-if="vehicleError">
            <div class="form-other-title" style="opacity: 0">
            </div>
            <div class="form-other-error">
              この車両は同じ時間に別の便で使用されています。別の車両を選択するか、時刻を修正してください。
            </div>
          </div>
          <!-- 交通事業者エラー行 -->
          <div class="form-other-row" 
              style="margin-top: 4px; height: 20px; min-height: 20px;"
              v-if="transportIdError">
            <div class="form-other-title" style="opacity: 0">
            </div>
            <div class="form-other-error">
              ドライバーと車両の交通事業者が異なります。
            </div>
          </div>
          <div class="form-other-row">
            <div class="form-other-meter">
              <div class="form-meter-title">
                出発メーター
              </div>
              <div class="form-meter-input">
                <div>
                  <input type="text" 
                  v-model="shiftInfo.startDistance"
                  name='startDistance'
                  v-validate="'numeric|required'"
                  maxlength="9"
                  @change="changeMeter()"
                  >km
                </div>
                <div class="form-meter-error" v-if="errors.has('startDistance')">
                  {{ errors.first('startDistance') }}
                </div>
              </div>
            </div>
            <div class="form-other-meter">
              <div class="form-meter-title">
                到着メーター
              </div>
              <div class="form-meter-input">
                <div>
                  <input type="text" 
                  v-model="shiftInfo.returnDistance"
                  name='returnDistance'
                  v-validate="'numeric|required'"
                  maxlength="9"
                  @change="changeMeter()"
                  >km
                </div>
                <div class="form-meter-error" v-if="errors.has('returnDistance')">
                  {{ errors.first('returnDistance') }}
                </div>
              </div>
            </div>
            <div class="form-other-meter">
              <div class="form-meter-title">
                走行距離
              </div>
              <div class="form-meter-data">
                <div>
                  {{(shiftInfo.totalDistance!=null)?(shiftInfo.totalDistance).toLocaleString():""}}<span v-show="shiftInfo.totalDistance!==null">km</span>
                </div>
                <div class="form-meter-error" v-if="distanceError">
                  走行距離の値が不正です。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-passenger">
          <div class="form-passenger-row"
                v-for="(shiftReservation, key1) in shiftInfo.shiftReservationInfos" :key="key1">
            <div class="form-passenger-form">
              <div class="form-passenger-title-s">
                乗客
              </div>
              <div class="form-passenger-name">
                {{shiftReservation.lastName}} {{shiftReservation.firstName}}
              </div>
              <div class="form-passenger-title-s">
                乗車
              </div>
              <div class="form-passenger-checkbox">
                <input type="checkbox"
                  v-model="shiftReservation.pickupFlag"
                  @change="changePickupFlag(shiftReservation.reserveId, shiftReservation.pickupFlag)">
              </div>
              <div class="form-passenger-title">
                乗車場所
              </div>
              <div class="form-passenger-start">
                <select class="form-passenger-select common-select"
                  v-model="shiftReservation.startStationId"
                  v-validate="'required'"
                  :name='`startStationId${key1}`'
                  @change="changeStartStation(shiftReservation.reserveId, shiftReservation.startStationId, key1)"
                  :disabled="!shiftReservation.pickupFlag">
                  <option v-for="(passpoint, index) in shiftInfo.shiftPasspoints" 
                    :value="passpoint.stationId" 
                    :key="passpoint.stationId"
                    v-if="passpoint.routeType=='0'
                        && passpoint.officeFlag == 0
                        && index != shiftInfo.shiftPasspoints.length - 1">{{passpoint.stationName}}</option>
                  <option v-for="passpoint in shiftInfo.shiftPasspoints" 
                    :value="passpoint.stationId" 
                    :key="passpoint.stationId"
                    v-if="passpoint.routeType=='1' 
                        && shiftInfo.shiftFlag === 0
                        && shiftInfo.transportKind == 0
                        && passpoint.stationId === shiftReservation.reserveId">自宅</option>
                </select>
              </div>
              <div class="form-passenger-title">
                降車場所
              </div>
              <div class="form-passenger-arrive">
                <select class="form-passenger-select common-select"
                  v-model="shiftReservation.arriveStationId"
                  v-validate="'required'"
                  :name='`arriveStationId${key1}`'
                  @change="changeArriveStation(shiftReservation.reserveId, shiftReservation.arriveStationId, key1)"
                  :disabled="!shiftReservation.pickupFlag">
                  <option v-for="passpoint in shiftInfo.shiftPasspoints" 
                    :value="passpoint.stationId" 
                    :key="passpoint.stationId"
                    v-if="passpoint.routeType=='0'
                        && passpoint.sortNo != 1
                        && passpoint.officeFlag == 0
                        && passpoint.sortNo > shiftReservation.startStationNumber">{{passpoint.stationName}}</option>
                  <option v-for="passpoint in shiftInfo.shiftPasspoints" 
                    :value="passpoint.stationId" 
                    :key="passpoint.stationId"
                    v-if="passpoint.routeType=='1' 
                        && shiftInfo.shiftFlag === 1
                        && shiftInfo.transportKind == 0
                        && passpoint.stationId === shiftReservation.reserveId">自宅</option>
                </select>
              </div>
              <div class="form-passenger-title-s">
                乗員
              </div>
              <div class="form-passenger-count">
                <input type="text"
                v-model="shiftReservation.passengerNumber"
                :name='`passengerNumber${key1}`'
                v-validate="shiftReservation.pickupFlag?'required|numeric':''"
                maxlength="2"
                :disabled="!shiftReservation.pickupFlag"
                @change="changePassengerNumber()"
                >人
              </div>
              <div class="form-passenger-title">
                利用料金
              </div>
              <div class="form-passenger-cost">
                <input type="text" 
                v-model="shiftReservation.passengerCost"
                :name='`passengerCost${key1}`'
                v-validate="shiftReservation.pickupFlag?'required|numeric':''"
                maxlength="5"
                :disabled="!shiftReservation.pickupFlag"
                >円
              </div>
            </div>
            <div class="form-passenger-errors" v-if="errors.has('arriveStationId' + key1)">
              【降車場所】{{ errors.first('arriveStationId' + key1) }}
            </div>
            <div class="form-passenger-errors"
            v-if="shiftReservation.passengerNumberError2">
              【乗員】1以上の数値を入力してください。
            </div>
            <div class="form-passenger-errors"
            v-if="errors.has('passengerNumber' + key1)">
              【乗員】{{ errors.first('passengerNumber' + key1) }}
            </div>
            <div class="form-passenger-errors"
            v-if="errors.has('passengerCost' + key1)">
              【利用料金】{{ errors.first('passengerCost' + key1) }}
            </div>
            <div class="form-passenger-errors"
            v-if="passengerNumberError1 && key1 == shiftInfo.shiftReservationInfos.length - 1 ">
              乗員の合計が車両の定員を超えています。
            </div>
          </div>
        </div>
        <div class="form-other">
          <div class="form-other-row">
            <div class="form-other-title">
              訂正理由・備考
            </div>
            <div class="form-other-textarea">
              <textarea maxlength=255 v-model="shiftInfo.correctNote"></textarea>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div class="common-width button-area">
    <div>
      <div @click="submit()">保存</div>
      <div @click="cancel()">キャンセル</div>
    </div>
  </div>
  <showMap ref="showMapWindow"></showMap>
</main-layout>

</template>

<style lang="scss" scoped>
.common-width{
    // max-width: 1600px;
    width: 96%;
    margin-right: auto;
    margin-left: auto;
    font-size: 15px;
    color: #505050;
    font-weight: 400;
}

.common-select{
  outline: none;
  text-indent: 1px;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: url("../../assets/dropselect.png") no-repeat scroll 100% transparent;
  border: 1px solid #ccc;
  border-radius: 10px;
  height: 50px;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
  padding-left: 12px;
  background-color: #fff!important;
}

.section-wrapper{
  overflow: auto;
  padding-bottom: 100px;
}
.title-area {
    .title-title{
        height: 60px;
        margin-top: 20px;
        line-height: 60px;
        text-align: center;
        font-family: Noto Sans CJK JP!important;
        color: #505050!important;
        font-size: 27px!important;
        font-weight: 500!important;
    }
}
section.passenger-area {
  margin-top: 20px;

    table{
      border: 1px solid #959595;
      width: 100%;
      
      .passenger-row{
        height: 50px;
        line-height: 50px;
      }

      td{
        border: 1px solid #959595;
      }
  
      .passenger-title{
        // width: 10%;
        font-size: 15px;
        text-align: center;
        background-color: #DAE1E6;
      }
  
      .passenger-data{
          // width: 90%;
          padding-left: 10px;
          font-size: 18px;
          text-align: left;
          >div{
            width: 100%;
            max-height: 100px;
            overflow-y: scroll;
          }
      }
    }

}
section.shift-area {
    border-top: solid 2px #bbb;
    padding-top: 20px;

    .shift-caption{
      font-size: 22px;
      text-align: center;
    }
    table{
      margin-top: 10px;
      border: 1px solid #959595;
      width: 100%;
      
      .shift-row{
        height: 50px;
        line-height: 50px;
      }

      td{
        border: 1px solid #959595;
      }
  
      .shift-title{
        // width: 10%;
        font-size: 15px;
        text-align: center;
        background-color: #DAE1E6;
      }
  
      .shift-data-text{
          width: 90%;
          padding-left: 20px;
          font-size: 18px;
          text-align: left;
      }

      .shift-data-num{
          width: 90%;
          padding-left: 0;
          font-size: 18px;
          text-align: center;
      }

      .shift-data-cost{
          padding-left: 20px;
          font-size: 18px;
          text-align: left;
      }

      .shift-data-coercion{
          padding-left: 12px;
          font-size: 18px;
          text-align: left;
      }

      .shift-disable{
        .shift-col-station{
          >span:nth-child(2){
            color:#c8c8c8;
          }
        }
        // 到着予定時間のセル
        >td:nth-child(4){
          color:#c8c8c8;
        }
      }

      .shift-col-1{
        width: 10%;
      }

      .shift-col-3{
        width: 70%;
      }

      .shift-col-station{
        width: 50%;
      }

      .shift-map{
        height: 30px;
        width: 80px;
        font-size: 18px;
        border: none;
        background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
        border-radius: 4px;
        float: right;
        margin: 9px;
        color: #FFF;
        font-size: 15px;
        line-height: 30px;
      }

      .shift-col-meter{
        display: flex;
        border: none;
        width: 180%;
        font-size: 18px;
        text-align: center;
        
        .shift-meter-data{
          border-right: 1px solid #959595;
          width: 10%;
        }
        .shift-meter-title{
          font-size: 15px;
          border-right: 1px solid #959595;
          width: 10%;
          background-color: #DAE1E6;
        }
      }
    }

}
section.form-area {
  margin-top: 40px;
  border-top: solid 2px #bbb;
  padding-top: 20px;

  .form-caption{
    font-size: 22px;
    text-align: center;
  }
  .form-pass{
    margin-top: 20px;

    .form-pass-table{
      width: 100%;
      
      .form-pass-hidden{
        display: none!important;
      }

      .form-pass-row{
        display: flex;
        margin-top: 10px;
        min-height: 50px;
        // height: 50px;
        line-height: 50px;
        
        .form-pass-title{
          max-width: 120px;
          width: 120px;
          min-width: 120px;
          max-height: 50px;
          background-color: #DAE1E6;
          text-align: center;
        }

        .form-pass-name{
          margin-left: 10px;
          margin-right: 10px;
          width: 40%;
          max-height: 50px;
          background-color: #EEEEEE;
          padding-left: 20px;
          font-size: 20px;
          overflow: hidden;
          text-align: left;
        }

        .form-pass-disable{
          color: #9E9E9E;
        }

        .form-pass-time{
          min-width: 220px;
          text-align: center;
          font-size: 17px;

          select{
            outline: none;
            // float: right;
            text-indent: 1px;
            -moz-appearance: none;
            -webkit-appearance: none;
            background: url("../../assets/dropselect.png") no-repeat scroll 100% transparent;
            border: 1px solid #ccc;
            border-radius: 10px;
            width: 80px;
            height: 50px;
            line-height: 20px;
            font-size: 16px;
            text-align: left;
            padding-left: 12px;
            background-color: #fff!important;
          }
        }

        .form-pass-wait{
          // display: flex;
          margin-left: 10px;
          min-width: 120px;
          width: 120px;

          >div:first-child{
            display: flex;
          }

          .form-wait-time{
            // display: flex;
            margin-left: 10px;
            width: 120px;

            input{
              width: 120px;
              margin-right: 6px;
              padding-right: 12px;
              font-size: 20px;
              height: 50px;
              text-align: right;
            }
            .form-wait-input{
              display: flex;
            }
          }
          .form-wait-error{
            width: 200%;
            font-size: 14px;
            text-align: left;
            height: 24px;
            line-height: 24px;
            color: red;
          }
        }

        .form-pass-time-error{
          font-size: 14px;
          text-align: center;
          height: 24px;
          line-height: 24px;
          color: red;
        }

        .form-pass-station{
          background-color: unset;

          > span{
            display: none;
          }
        }
      }
    }
    .form-other{
      width: 100%;
      margin-top: 40px;

      .form-other-row{
        display: flex;
        margin-top: 10px;
        min-height: 50px;
        // height: 50px;
        line-height: 50px;
        
        .form-other-title{
          max-width: 120px;
          width: 120px;
          min-width: 120px;
          max-height: 50px;
          background-color: #DAE1E6;
          text-align: center;
        }

        .form-other-data{
          margin-left: 10px;
          width: 40%;
          max-width: 660px;
          max-height: 50px;
          background-color: #EEEEEE;
          padding-left: 20px;
          font-size: 20px;
          text-align: left;
        }

        .form-other-select{
          margin-left: 10px;
          width: 40%;
          max-width: 660px;
          max-height: 50px;
          font-size: 20px;
          text-align: left;

          >select{
            width: 100%;
            height: 50px;
            font-size: 20px;
            padding-left: 20px;
          }
        }

        .form-other-textarea{
          margin-left: 10px;
          width: 100%;
          max-height: 100px;
          font-size: 20px;
          text-align: left;

          >textarea{
            width: 100%;
            min-width: 400px;
            height: 100px;
            min-height: 100px;

            padding-left: 20px;
          }
        }

        .form-other-error{
          margin-left: 12px;
          text-align: right;
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: red;
        }

        .form-other-meter{
          display: flex;
          width: 30%;

          .form-meter-title{
            max-width: 120px;
            width: 120px;
            min-width: 120px;
            max-height: 50px;
            background-color: #DAE1E6;
            text-align: center;
          }
          .form-meter-input{
            // display: flex;
            margin-left: 10px;
            width: 57%;

            >div{
              display: flex;
            }

            input{
              width: 100%;
              margin-right: 6px;
              padding-right: 12px;
              text-align: right;
              font-size: 20px;
              height: 50px;
            }
          }
          .form-meter-data{
            width: 100%;

            >div:first-child{
              margin-left: 10px;
              width: 60%;
              height: 50px;
              min-width: 160px;
              background-color: #EEEEEE;
              padding-right: 12px;
              font-size: 20px;
              text-align: right;
              overflow: hidden;
            }
          }
          .form-meter-error{
            margin-left: 12px;
            text-align: left;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            color: red;
          }
        }
      }
    }
    .form-passenger{
      margin-top: 10px;
      width: 100%;
      min-width: 600px;

      .form-passenger-form{
        display: flex;
        width: 100%;
        height: 50px;
        line-height: 50px;

        >div:not(:nth-child(1)){
            margin-left : 10px;
        }

        .form-passenger-title{
            width: 80px;
            min-width: 80px;
            max-height: 50px;
            background-color: #DAE1E6;
            text-align: center;
        }

        .form-passenger-title-s{
            width: 60px;
            min-width: 60px;
            max-height: 50px;
            background-color: #DAE1E6;
            text-align: center;
        }

        .form-passenger-name{
          width: 33%;
          min-width: 160px;
          background-color: #EEEEEE;
          padding-left: 12px;
          font-size: 20px;
          text-align: left;
          overflow: hidden;
        }

        .form-passenger-start{
          width: 50%;
          min-width: 160px;
          text-align: left;
        }

        .form-passenger-arrive{
          width: 50%;
          min-width: 160px;
          text-align: left;
        }

        .form-passenger-select{
          font-size: 20px;
          overflow: hidden;
          width: 100%;
        }

        .form-passenger-checkbox{
          display: flex;
          align-items: center;

          >input{
            margin: 0;
            width: 30px;
            height: 30px;
          }
        }

        .form-passenger-count{
          min-width: 70px;
          >input{
              width: 40px;
          }
        }

        .form-passenger-cost{
          min-width: 90px;
          >input{
              width: 66px;
          }
        }

        .form-passenger-count, .form-passenger-cost{
          input{
            margin-right: 6px;
            // padding-left: 6px;
            text-align: right;
            font-size: 20px;
            height: 50px;
          }
        }
      }

      .form-passenger-errors{
        text-align: left;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        color: red;
      }
      
      >div.form-passenger-row:not(:nth-child(1)){
        margin-top: 10px;
          // border-top: solid 1px #bbb;
      }
    }
  }

}
.button-area{
  display: flex;
  margin-bottom: 10px;
  >div{
    width: 80%;
    max-width: 1080px;
    display: flex;
    margin: auto;

    >div{
      margin: 10px;
      max-width: 520px;
      width: 85%;
      height: 50px;
      line-height: 50px;
      background-color: #48A3BE;
      text-align: center;

      border-radius: 10px;
      font-size: 20px;
      color: #fff;
      background: linear-gradient(#70b6ca 50%,#48a3be 0);
      border: 0;

    }

    >div:hover{
      cursor: pointer;
      opacity: 0.8;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/router/views/EditMovementWork.vue